module.exports = __webpack_public_path__ + "static/media/delete.61c84975.svg";